import { useCallback } from 'react'
import tinycolor from 'tinycolor2'

import { getCommitHex } from '../../../ColorPickerPopover.utils'

import { parseRgbChannel } from './useColorPickerPreviewCommit.utils'

export function useColorPickerPreviewCommit(onManualColorChange) {
  const commitHex = useCallback(
    nextHex => {
      onManualColorChange?.(getCommitHex(nextHex))
    },
    [onManualColorChange]
  )

  const tryCommitRgb = useCallback(
    (rStr, gStr, bStr) => {
      const r = parseRgbChannel(rStr)
      const g = parseRgbChannel(gStr)
      const b = parseRgbChannel(bStr)

      if (r == null || g == null || b == null) {
        return false
      }

      commitHex(tinycolor({ b, g, r }).toHexString().toUpperCase())

      return true
    },
    [commitHex]
  )

  return { commitHex, tryCommitRgb }
}
